import BaseCardBehavior from './BaseCardBehavior';
import { IGameState } from 'State/Game/IGameState';

export default class JokerCardBehavior extends BaseCardBehavior {
    public isPlayable(state: IGameState) {
        return false;
    }
}
